import { render, staticRenderFns } from "./TermsList.vue?vue&type=template&id=667e9e36&scoped=true&"
import script from "./TermsList.vue?vue&type=script&lang=js&"
export * from "./TermsList.vue?vue&type=script&lang=js&"
import style0 from "./TermsList.vue?vue&type=style&index=0&id=667e9e36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667e9e36",
  null
  
)

export default component.exports